import { SubCatVo } from "./SubCatVo";
import { TopicVo } from "./TopicVo";

export class CatVo {
    public id: number;
    public subjectID: number;
    public catName: string;
    public subcats:SubCatVo[]=[];
    //topics are only used in cats for language subjects
    public topics:TopicVo[]=[];
    public icon:string="";
    constructor(id: number, subjectID: number, catName: string,icon:string="") {
        this.id = id;
        this.subjectID = subjectID;
        this.catName = catName;
        this.icon=icon;
    }
}